<template>
  <small class="generation-model-details" :title="`实际生图模型：${model}`">
    <i class="el-icon-cpu"></i><b>生图模型</b><span>{{ model }}</span>
  </small>
</template>
<script>
import { formatModelName } from '@/utils/modelDisplay'

export default {
  name: 'GenerationModelDetails',
  props: { record: { type: Object, default: null } },
  computed: {
    model() {
      const record = this.record || {}
      if (record.imageModel) return formatModelName(record.imageModel)
      const tasks = record.taskStates || record.tasks || []
      return [...new Set(tasks.map(task => formatModelName(task && task.imageModel)).filter(Boolean))].join(' / ') || '历史任务未记录'
    }
  }
}
</script>
<style scoped>
.generation-model-details{min-width:0;display:flex;align-items:center;gap:5px;margin:6px 10px;color:#64748b!important;font-size:8px!important;line-height:1.4}.generation-model-details>i{color:#4774ca}.generation-model-details>b{flex:0 0 auto;color:#53647d;font-size:8px}.generation-model-details>span{min-width:0;overflow:hidden;color:#2859ad;text-overflow:ellipsis;white-space:nowrap}
</style>
